export default __webpack_public_path__ + "static/media/diamond.cdf3cf4b.svg";